let pageConfig = {};

// 列表展示项
pageConfig.listColumns = [
    {
        label: '电表户号',
        props: 'accountNo',
        minWidth: 180,
    },

    {
        label: '电表名称',
        props: 'elecName',
        minWidth: 180,
        tooltip: true,
    },
    {
        label: '所属电站',
        props: 'stationName',
        minWidth: 200,
    },
    {
        label: '账单月份',
        props: 'yearMon',
        minWidth: 120,
        sortable: true,
    },
    {
        label: '平时度数（度）',
        props: 'peakAmmeter',
        minWidth: 160,
        sortable: true,
    },
    {
        label: '平时金额（元）',
        props: 'peakElecFee',
        minWidth: 160,
        tooltip: true,
    },
    {
        label: '谷时度数（度）',
        props: 'valleyAmmeter',
        minWidth: 160,
        tooltip: true,
    },
    {
        label: '谷时金额（元）',
        props: 'valleyElecFee',
        minWidth: 160,
        tooltip: true,
    },
    {
        label: '录入时间',
        props: 'lastModifiedWhen',
        minWidth: 200,
    },
    {
        label: '录入类型',
        props: 'editType',
        minWidth: 120,
    },
    {
        label: '录入人',
        props: 'lastModifiedByName',
        minWidth: 160,
    },
];
// 电站展示
pageConfig.stationListColumns = [
    {
        label: '所属电站',
        props: 'stationName',
        minWidth: 200,
    },
    {
        label: '所属电表',
        props: 'elecAccount',
        minWidth: 200,
        formatter: function formatter(row, column, cellValue, index) {
          
          return row.elecAccount.replace(/,/g, '</br>')
        }
    },
    {
        label: '账单月份',
        props: 'month',
        minWidth: 120,
        sortable: true,
    },
    {
        label: '平时度数（度）',
        props: 'peakAmmeter',
        minWidth: 160,
        sortable: true,
    },
    {
        label: '平时金额（元）',
        props: 'peakElecFee',
        minWidth: 160,
        tooltip: true,
    },
    {
        label: '谷时度数（度）',
        props: 'valleyAmmeter',
        minWidth: 160,
        tooltip: true,
    },
    {
        label: '谷时金额（元）',
        props: 'valleyElecFee',
        minWidth: 160,
        tooltip: true,
    },
    {
        label: '电表总度数',
        props: 'ammeterElecAll',
        minWidth: 200,
    },
    {
        label: '订单电量',
        props: 'chargeElecAll',
        minWidth: 120,
    },
    {
        label: '电表总金额',
        props: 'ammeterFeeAll',
        minWidth: 160,
    },
    {
        label: '订单金额',
        props: 'chargeFeeAll',
        minWidth: 160,
    },
];

// // 面包屑
pageConfig.listBreadCrumb = [
    {
        type: 'title',
        name: '首页',
    },
    {
        type: 'title',
        name: '充电管理'
    },
    {
        type: 'title',
        name: '电站总表'
    }
];

// 列表-表格属性
pageConfig.tableConfig = {
    showSelection: true,
    showIndex: true,
};

// 列表-分页参数
pageConfig.pagination = {
    current: 1,
    total: 0,
    pageSize: 10,
    pageSizes: [10, 20, 50, 100],
}


export default pageConfig;
